import {onError} from '@apollo/client/link/error'
import rollbar from '@cred/shared/rollbar'
import {configureRollbar, isE2EMode, isClient} from '../../../utils'
import config from 'config'

function getLoginRedirectLink(cookies, {redirect, serverContext}) {
  return onError(({response, graphQLErrors}) => {
    if (graphQLErrors) {
      const email = cookies.get('email')

      if (email) {
        configureRollbar(decodeURIComponent(email))
      }

      graphQLErrors.map(({message, path}) => {
        if (['Unauthorized', 'NoToken', 'TokenExpired'].includes(message)) {
          rollbar.error(`[Login Redirect] user redirected to loginUrl - resolver: ${path}`, {
            cookies: cookies.cookies
          })
          if (['NoToken', 'TokenExpired'].includes(message)) {
            const originalUrl = isClient() ? window.location.href : serverContext.originalUrl
            const redirectUrl = `${config.loginUrl}${config.loginUrl.includes('?') ? '&' : '?'}redirectTo=${encodeURIComponent(originalUrl)}`

            redirect(redirectUrl)
          } else {
            redirect(config.loginUrl)
          }

          // Prevent errors from being thrown by Apollo.
          response.errors = null
        }
      })
    }
  })
}

export default getLoginRedirectLink
